// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3RXmI","title":"InfoRow_title__1_dOk"};